<template>
  <el-collapse v-model="collapseModel">
    <elemento-header
      :title="title"
      :name="name"
    >
      <input-suaje
        v-model="localModel"
        :validate="validarEspecificacionTecnicaCampos"
        v-bind="componentsProps.InputSuaje"
        @update:unidadImposicion="onUnidadImposicionChange"
      />

      <input-procesos
        v-model="localModel.Secciones"
        :elemento-tipo="localModel.ElementoTipo"
      />
      <el-divider></el-divider>
    </elemento-header>
  </el-collapse>
</template>

<script setup>
import {
  onBeforeMount,
  provide,
  ref,
  computed,
} from 'vue';
import { storeToRefs } from 'pinia';
import { useElemento } from '@/shared/composables/useElemento.js';
import { useTechnicalSpecificationStore } from '@/views/technical_specifications/stores/technical_specification_store.js';
import { useUnidadImposicionProvider } from '@/shared/composables/use_unidad_imposicion.js';
import InputProcesos from '@/shared/components/procesos/input_procesos.vue';
import InputSuaje from '@/shared/components/suaje/input_suaje.vue';
import { useComponentsProps } from '@/shared/composables/use_components_props.js';
import { Modules } from '@/enum/modules';
import { ElementoBase } from '@/enum/elemento_base';
import { useAnchoMinimoMM } from '@/shared/composables/use_ancho_minimo.js';

const emit = defineEmits(['update:modelValue']);

const technicalSpecificationStore = useTechnicalSpecificationStore();
const { validarEspecificacionTecnicaCampos } = storeToRefs(technicalSpecificationStore);
const { componentsProps } = useComponentsProps(
  ElementoBase.CONSUMIBLE,
  Modules.ESPECIFICACION_TECNICA,
);

const props = defineProps({
  modelValue: { type: Object, required: true },
  title: { type: String, required: true },
  name: { type: String, required: true },
});

const { localModel, collapseModel, updateModelo } = useElemento(props, emit);
const { anchoMinimoMM } = useAnchoMinimoMM(localModel);
const selectedMaterialAnchoMM = ref(0);

// Proveer valores de imposición para componentes de proceso
const imposicionProvidedValue = computed(() => ({
  EtiquetasEje: localModel.value.EtiquetasEje || 0,
  EtiquetasDesarrollo: localModel.value.EtiquetasDesarrollo || 0,
}));

provide('currentElementoBase', ElementoBase.CONSUMIBLE);
provide('anchoMinimoMM', anchoMinimoMM);
provide('selectedMaterialAnchoMM', selectedMaterialAnchoMM);
provide('imposicion', imposicionProvidedValue);
const { onUnidadImposicionChange } = useUnidadImposicionProvider(localModel);

onBeforeMount(() => {
  updateModelo({
    EtiquetasPaso: 1,
    Engranaje: 1,
    MateriaPrimaFamilia: {
      Descripcion: 'Consumible',
      Codigo: 39,
    },
    Forma: { Codigo: 1, Descripcion: 'Rectangular' },
  });
});
</script>

<style scoped>
.detail-container-printed {
  padding: 0;
}
.custom-label {
  font-weight: 700;
  color: #111;
}

.colors-button {
  width: 100%;
}
</style>
